const customerSupportSlider = document.querySelectorAll('[data-slider="customer-support-slider"]');

const customerSupportSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  freeMode: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
      freeMode: false,
      slidesPerGroup: 2,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
      freeMode: false,
      slidesPerGroup: 2,
    },
    1600: {
      slidesPerView: 5,
      spaceBetween: 20,
      freeMode: false,
      slidesPerGroup: 2,
    },
  },
};

const initCustomerSupportSlider = () => {
  customerSupportSlider.forEach((el) => {
    const parentEle = el.closest('.customer-support');
    const scrollbar = parentEle.querySelector('.swiper-scrollbar');

    const arrowRight = parentEle.querySelector('.arrow-right');
    const arrowLeft = parentEle.querySelector('.arrow-left');

    customerSupportSliderOptions.navigation.nextEl = arrowRight;
    customerSupportSliderOptions.navigation.prevEl = arrowLeft;
    customerSupportSliderOptions.scrollbar.el = scrollbar;

    if (windowWidth() > 767) {
      new Swiper(el, customerSupportSliderOptions);
    } else {
      enableScrollbarSync(parentEle);
    }
  });
};

initCustomerSupportSlider();

setupResponsiveSliders({
  sliderElements: customerSupportSlider,
  breakpoint: 767,
  initSlider: initCustomerSupportSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
